module.exports = __webpack_public_path__ + "static/media/mbr-936x597.1a6e3349.jpg";